module.exports = __webpack_public_path__ + "img/delete.420f755a.png";